import React, { useState, useEffect } from "react";
import { injectModels } from "../../../redux/injectModels";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  EventApplicationRetailService,
  PaymentService,
  InvoiceService,
  DocumentTypeService,  
} from "../../../services";
import { getBusinessProfileById } from "../../../services/BusinessProfileService";
import { AuthService } from "../../../services";
import { Table, Form, Modal, Button } from "react-bootstrap";
import { BusinessProfileModel } from "../../../components/Model/businessProfileModel";
import { toast } from "react-toastify";
import { routes } from "../../../constants/routes";
import {
  ApplicationStatus,
  UserRoleType,
  PaymentStatus,
} from "../../../constants/Enum";
import { EventContractService } from "../../../services";
import { DocumentService } from "../../../services";
import { globalConstant } from "../../../constants/globalConstant";
import {
  formatAmount,
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";
import Swal from "sweetalert2";

const html2pdf = require("html2pdf.js");

const EventRetailerSubmissionDetails = (props) => {
  const navigate = useNavigate();
  const { appId } = useParams();
  const loginUser = AuthService.getLoginUser();
  const [appData, setApplication] = useState();
  const [businessData, setBusinessData] = useState(BusinessProfileModel);
  const [pitchData, setPitch] = useState();
  const [booking, setBookingForm] = useState(null);
  const [isApproved, setIsApproved] = useState(false);
  const [formValue, setFormValues] = useState({
    Invoicebyid: null,
    invoiceAdmin: null,
  });
  const location = useLocation();
  const { eventId } = useParams();
  const [showurl, setShowUrl] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showBankPaymentModal, setShowBankPaymentModal] = useState(false);
  const [bankPaymentComment, setBankPaymentComment] = useState("");
  const [selectedIdx, setSelectedIdx] = useState(null); // Index of the row being edited
  const [newAllocatedPitchNo, setNewAllocatedPitchNo] = useState(""); // New allocatedPitchNo input
  const [paymentStatus, setPaymentStatus] = useState(PaymentStatus.Unpaid);
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [documentList, setDocumentList] = useState([]);
  const [litterData, setLitterData] = useState();
  const [error, setError] = useState();
  //const [vatNumber, setVatNumber] = useState("");

  // const [formValue1, setFormvalues1] = useState();

  const handleOpenModal = (id, allocatedPitchNo) => {
    const data = pitchData.filter((item) => item.id === id);
    setSelectedIdx(id);
    if (data) {
      data.allocatedPitchNo = allocatedPitchNo;
      setPitch(pitchData);
    }
    setNewAllocatedPitchNo(allocatedPitchNo || ""); // Set value if it exists
    setShowModal(true);
  };

  // Function to handle the input change in modal
  const handleInputChange = (e) => {
    setNewAllocatedPitchNo(e.target.value);
  };

  const getObscuredTextLabel = (text) => {
    return isApproved ? text : "*************";
  };
  const getObscuredText = () => {
    return isApproved ? {} : { filter: "blur(4px)" };
  };

  const handleSave = async () => {
    setError("");

    // if (newAllocatedPitchNo !== "") {
    if (newAllocatedPitchNo && newAllocatedPitchNo.trim() !== "") {
      const updatedPitchData = [...pitchData];
      updatedPitchData[selectedIdx] = {
        ...updatedPitchData[selectedIdx],
        allocatedPitchNo: newAllocatedPitchNo, // Update the allocatedPitchNo
      };
      try {
        const request = {
          id: selectedIdx,
          allocatedPitchNo: newAllocatedPitchNo,
        };
        var response = await EventApplicationRetailService.AddEditPitchAllocation(
          request
        );
        if (response?.isSuccess) {
          setPitch(updatedPitchData);
          getData();
        }
      } catch (error) {
        handleConsoleError(error);
        toast.error(error?.message);
      }
      setShowModal(false);
    } else {
      setError("Please enter allocated pitch number");
      setShowModal(true);
    }
  };
  const getDocumentList = async () => {
    try {
      const res = await EventApplicationRetailService.getRetailApplicationDocuments(
        appId
      );
      if (res?.isSuccess) {
        setDocumentList(res?.data);
      }
      // else{
      //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      // }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  // Function to close the modal without saving
  const handleCloseModal = () => {
    setShowModal(false);
  };

   //************ Bank payment update in case of Swallow EO********/
  
    const IsBankPayment =
      props?.application?.swallowEO?.toLowerCase() ===
      loginUser?.id?.toLowerCase() && paymentStatus === PaymentStatus.PartiallyPaid;
  
    const handleBankPayment = async () => {
  
  if (!bankPaymentComment || bankPaymentComment?.trim() === "") {
       setError("Please enter comment");
      // console.log("AAA :: handleBankPayment ");
       return;
  }
  else{
     setError("");
  }
      //  if (paymentStatus === PaymentStatus.PartiallyPaid) {
     // console.log("AAA :: update bank payment.......");
  
      //save payment details
      const paymentIntentDetails = {
        applicationId: appId,
        comment: bankPaymentComment,
      };
  
      try {
        props.application.setLoading(true);
  
        const res = await PaymentService.saveBankPaymentDetails(
          paymentIntentDetails
        );
        if (res?.isSuccess && res?.data) {
          props.application.setLoading(false);
          toast.success("Payment completed successfully");
          handleCloseBankPaymentModal();
           navigate(
          routes.SUBMISSION_RETAILER.replace(":eventId", appData?.eventId)
        );
        }
      } catch (error) {
       const message= handleConsoleError(error);
        props.application.setLoading(false);
        toast.error(error?.message ?? message);
      }
  
      // }
      // else{
      //    console.log('AAA :: Already updated bank payment.......');
      // }
    };
  
      const handleCommentInputChange = (e) => {
      setBankPaymentComment(e.target.value);
    };
  
      // Function to close the modal without saving
        const handleBankPaymentOpenModal = () => {  
      setShowBankPaymentModal(true);
    };
  
  
    const handleCloseBankPaymentModal = () => {
      setBankPaymentComment("");
      setShowBankPaymentModal(false);
    };

  useEffect(() => {
    // getGlobalValues();
    const fetchData = async () => {
      await Promise.all([
        props.application.getSwallowEO(),
        getData(),
        getLitterData(),
        getPaymentStatusData(),
        getContractData(eventId),
      ]);
    };
    fetchData();
  }, []);

  const getPaymentStatusData = async () => {
    try {
      const res = await PaymentService.getPaymentStatusByAppId(appId);
      if (res?.isSuccess && res?.data) {
        setPaymentStatus(res?.data?.status);
        setRemainingAmount(res?.data?.remainingAmount);
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const getLitterData = async () => {
    try {
      const res = await EventApplicationRetailService.getRetailApplicationPaymentById(
        appId
      );
      if (res?.isSuccess && res?.data.length > 0) {
        setLitterData(res?.data);
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const getData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await EventApplicationRetailService.getRetailApplicationById(
          appId
        );
        if (res?.isSuccess) {
          setApplication(res?.data);

          if (
            ((res?.data?.status === ApplicationStatus.Approved ||
              res?.data?.status === ApplicationStatus.Completed) &&
              loginUser?.role === UserRoleType.EO) ||
            loginUser?.role === UserRoleType.TRADERRETAILER ||
            loginUser?.role === UserRoleType.MOBILECATERERS
          ) {
            setIsApproved(true);
          } else {
            setIsApproved(false);
          }
          setPitch(res?.data?.objEventApplicationRetailPitchDtlViewModel);
          getBusinessProfile(res?.data?.traderId);
          setShowUrl(res?.data?.docusignURL);
          getDocumentList();
        }
        // else{
        //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        // }
        await invoiceData(res?.data?.id);

        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const getBusinessProfile = async (id) => {
    try {
      //const userId = loginUser?.id;
      const business = await getBusinessProfileById(id);

      if (business?.isSuccess) {
        business.data.video = "";

        setBusinessData(business?.data);
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleApprove = async () => {
    try {
      props.application.setLoading(true);
      const pitchStatusResponse = await EventApplicationRetailService.getRetailApplicationPitchStatus(
        appId,
        appData?.pitchId
      );
      if (
        pitchStatusResponse?.isSuccess &&
        pitchStatusResponse?.data &&
        pitchStatusResponse?.data?.canApprove
      ) {
        const res = await PaymentService.capturePaymentByAppId({
          ApplicationId: appId,
        });
        if (res?.isSuccess) {
          if (res?.data) {
            await handleAccept(ApplicationStatus.Approved);
          }
          props.application.setLoading(false);
        } else {
         // toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
          props.application.setLoading(false);
        }
      } else {
        props.application.setLoading(false);
        Swal.fire({
          title: "Approval",
          text: pitchStatusResponse?.message,
          icon: "warning",
          buttonsStyling: false,
        });
      }
    } catch (error) {
      const message=handleConsoleError(error)
      props.application.setLoading(false);
      toast.error(error?.message ||message);
    }
  };

  const handleAccept = async (status) => {
    props.application.setLoading(true);
    try {
      const response = await EventApplicationRetailService.updateRetailApplicationStatus(
        {
          id: appData?.id,
          status: status,
        }
      );
      if (response?.isSuccess) {
        if (ApplicationStatus.Approved === status) {
          await sendingMail(formValue);
        }
        if (ApplicationStatus.Rejected === status) {
          await cancelPayment(appData?.id);
        }
        toast.success(response?.message);
        props.application.setLoading(false);
        navigate(
          routes.SUBMISSION_RETAILER.replace(":eventId", appData?.eventId)
        );
      } else {
        props.application.setLoading(false);
        if (response) {
          toast.error(response?.message);
        }
      }
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const handleBack = () => {
    navigate(routes.ACCOUNT_APPLICATIONS);
  };

  const cancelPayment = async (appId) => {
    const res = await PaymentService.cancelPaymentByAppId({
      ApplicationId: appId,
    });
    if (res?.isSuccess) {
      if (res?.data) {
      } else {
        //setSeletedPlan("no plan");
      }
    }
  };

  

  // ************ Get HandBook PDF    **********************
  const handbookspdf = async (booking, formValue) => {
    try {
      let contractDetails = booking
        .filter((item) => item.contractName === "HandBook Retailers")
        .map((item) => item.contractDtl)
        .join("<br><br>");

      if (!contractDetails) {
        console.warn("No contract details found");
        return;
      }

      const pdfContent = `
       <div style="width: 100%; text-align: center; padding: 20px;">
         <table style="width: 100%;">
           <tr>
              <td style="text-align: center;">
                    <img src="${formValue?.Invoicebyid?.businessLogo ||
                      ""}" alt="Company Logo" style="height: 100px;">
              </td>
            </tr>
            <tr>
              <td style="text-align: center;">
                <img src="/swallow-events-contract.jpg" alt="GWCT Logo" style="height: 100px;">
              </td>
            </tr>       
         </table>
       </div>
       <hr style="margin: 10px 0;">
       <div style="padding: 20px;">
         ${contractDetails}  <!-- 🟢 Yeh content proper format me hoga -->
       </div>
     `;

      const opt = {
        margin: [20, 20, 20, 20],
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        filename: `HandBooks.pdf`,
        image: { type: "jpeg", quality: 0.2 },
        html2canvas: {
          dpi: 150,
          scale: 2,
          letterRendering: true,
          useCORS: true,
        },
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "portrait",
          putTotalPages: true,
        },
      };

      return new Promise((resolve, reject) => {
        html2pdf()
          .set(opt)
          .from(pdfContent)
          .toPdf()
          .output("blob") // Generate the PDF as a Blob
          .then((pdfBlob) => {
            const file = new File([pdfBlob], "HandBooks.pdf", {
              type: "application/pdf",
            });
            resolve(file); // Return the PDF as a File object
          })
          .catch((error) => {
            handleConsoleError(error);
            reject(error);
          });
      });
    } catch (error) {
      handleConsoleError(error);
      throw error;
    }
  };

  // ************ Get Terms And Conditions PDF    **********
  const TermsAndConditionspdf = async (booking, formValue) => {
    try {
      let contractDetails = booking
        .filter((item) => item?.contractName === "Terms & Condition Retailers")
        .map((item) => item?.contractDtl)
        .join("<br><br>");

      if (!contractDetails) {
        console.warn("No contract details found");
        return;
      }

      // 🟢 Step 1: Create HTML structure with header
      const pdfContent = `
        <div style="width: 100%; text-align: center; padding: 20px;">
          <table style="width: 100%;">
           <tr>
              <td style="text-align: center;">
                    <img src="${formValue?.Invoicebyid?.businessLogo ||
                      ""}" alt="Company Logo" style="height: 100px;">
              </td>
            </tr>
            <tr>
              <td style="text-align: center;">
                <img src="/swallow-events-contract.jpg" alt="GWCT Logo" style="height: 100px;">
              </td>
            </tr>      
         
          </table>
        </div>
        <hr style="margin: 10px 0;">
        <div style="padding: 20px;">
          ${contractDetails}  <!-- 🟢 Yeh content proper format me hoga -->
        </div>
      `;

      const opt = {
        margin: [20, 20, 20, 20],
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        filename: `Terms&Conditons.pdf`,
        image: { type: "jpeg", quality: 0.2 },
        html2canvas: {
          dpi: 150,
          scale: 2,
          letterRendering: true,
          useCORS: true,
        },
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "portrait",
          putTotalPages: true,
        },
      };

      return new Promise((resolve, reject) => {
        html2pdf()
          .set(opt)
          .from(pdfContent)
          .toPdf()
          .output("blob") // Generate the PDF as a Blob
          .then((pdfBlob) => {
            const file = new File([pdfBlob], "Terms&Conditons.pdf", {
              type: "application/pdf",
            });
            resolve(file); // Return the PDF as a File object
          })
          .catch((error) => {
            handleConsoleError(error);
            reject(error);
          });
      });
    } catch (error) {
      handleConsoleError(error);
      throw error;
    }
  };

  //************Get Event Contract Data **********
  const getContractData = async (eventId) => {
    props.application.setLoading(true);
    try {
      const res = await EventContractService.getEventContractByEventId(eventId);
      if (res?.isSuccess) {
        setBookingForm(res?.data);
        props.application.setLoading(false);
      } else {
       // toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  //****   Invoice Data  *****
  const invoiceData = async (eventApplicationId) => {
    try {
      let Invoicebyid = {};
      const InvoiceByid = await InvoiceService.getInvoiceMainData(
        eventApplicationId,
        "R",
        false
      );
      if (InvoiceByid?.isSuccess) {
        Invoicebyid = InvoiceByid?.data;
      }
      setFormValues((prev) => ({
        ...prev,
        Invoicebyid: Invoicebyid, // updated value
      }));

      await InvoiceAdminData(eventApplicationId);
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  //******  Invoice PDF CODE *****************
  const InvoicePdf = async (formValue) => {
    try {
      var bankDetailsSwallowEO =
        loginUser?.id?.toLowerCase() ===
         props?.application?.swallowEO?.toLowerCase()
          ? "Payment to be made to: Swallow Events Ltd BACS: Lloyds: Account number 45749860 Sort code 309197"
          : "All Payment to be made to: @organiserLegalBusinessName@/g";
      var importantnote = `<p style="text-align: center; text-decoration: underline;">
                IMPORTANT-PAYMENT TERMS<br/>
                <br/>  
                  A ${appData?.initialPaymentPer}% SPACE RESERVATION DEPOSIT (INCLUDING ELECTRICITY AND ANY OTHER AGREED 
                  CHARGES) IS DUE IMMEDIATELY. THE DEPOSIT SECURES THE CATERER’S OR TRADER’S SPACE 
                  AT THE EVENT AND IS EARNED UPON CONFIRMATION. THE REMAINING BALANCE (EVENT SPACE 
                  DELIVERY FEE) IS DUE ON OR BEFORE ${formatDateENGB(appData?.payOutDate)} AND RELATES 
                  SOLELY TO DELIVERY OF THE SPACE OPPORTUNITY AT THE EVENT.SPACE ALLOCATIONS ARE MADE ON 
                  A FIRST-COME, FIRST-CONFIRMED BASIS, SUBJECT TO RECEIPT OF THE SPACE RESERVATION DEPOSIT. 
                  FAILURE TO PAY THE REMAINING BALANCE BY THE DUE DATE MAY RESULT IN THE SPACE BEING 
                  RELEASED IN ACCORDANCE WITH THE CONTRACT.
              </p>`;

              if(appData?.initialPaymentPer === 100)
              {
                 importantnote = `<p style="text-align: center; text-decoration: underline;">
                IMPORTANT-PAYMENT TERMS<br/>
                <br/>  
                  FULL PAYMENT (INCLUDING ELECTRICITY AND ANY OTHER AGREED CHARGES) IS DUE IMMEDIATELY.
                  SPACE IS NOT CONFIRMED UNTIL FULL PAYMENT HAS BEEN RECEIVED AND THE BOOKING HAS BEEN FORMALLY 
                  CONFIRMED BY THE COMPANY. SPACE ALLOCATIONS ARE MADE ON A STRICT FIRST-COME, FIRST-CONFIRMED BASIS. 
                  OF THE TOTAL AMOUNT PAID, 50% CONSTITUTES A NON-REFUNDABLE SPACE RESERVATION DEPOSIT EARNED UPON CONFIRMATION, 
                  WITH THE REMAINING BALANCE RELATING TO DELIVERY OF THE SPACE AT THE EVENT, IN ACCORDANCE WITH THE CONTRACT. 
                  FAILURE TO COMPLY WITH THE ABOVE PAYMENT TERMS MAY RESULT IN THE SPACE BEING RELEASED AND REALLOCATED WITHOUT FURTHER NOTICE.
              </p>`;

              }
      // var payoutMessage =
      //   appData?.initialPaymentPer === 100
      //     ? ``
      //     : `THE REMAINING BALANCE (EVENT SPACE 
      //             DELIVERY FEE) IS DUE ON OR BEFORE ${formatDateENGB(
      //               appData?.payOutDate
      //             )} AND RELATES SOLELY TO DELIVERY OF 
      //             THE SPACE OPPORTUNITY AT THE EVENT.`;

      // importantnote = importantnote
      //   .toString()
      //   .replace("@payOutDate@", payoutMessage);
     
      let html = globalConstant.InvoiceHTML;
      html = html
        .toString()
        .replace("@importantnote@", importantnote)
        .replace(
          "@vatNumber@",
          formValue?.Invoicebyid?.vatNo ??  ""
        )
        .replace(
          "@businessLogoUrl@",
          formValue?.Invoicebyid?.businessLogo || ""
        )
        .replace(
          "@businessRegistrationNumber@",
          formValue?.Invoicebyid?.vatNo ??  ""
        )
        .replace(
          "@vat@",
          formValue?.Invoicebyid?.vat ??  ""
        )
        .replace("@bankDetailsSwallowEO@", bankDetailsSwallowEO)
        .replace(
          "@invoiceNo@",
          formValue?.Invoicebyid?.invoiceNo ??  ""
        )
        .replace(
          "@address@",
          formValue?.Invoicebyid?.city ??  ""
        )
        .replace(
          "@invoiceAddress@",
          formValue?.Invoicebyid?.invoiceAddress
            ?? ""
        )
        .replace(
          "@businessLogoUrl@",
          formValue?.Invoicebyid?.businessLogoUrl
            ?? ""
        )
        .replace(
          "@eventName@",
          formValue?.Invoicebyid?.eventName ?? ""
        )
        .replace(
          "@organiserLegalBusinessName@",
          formValue?.Invoicebyid?.organiserLegalBusinessName
            ??  ""
        )
        .replace(
          "@organiserLegalBusinessName@/g",
          formValue?.Invoicebyid?.organiserLegalBusinessName
            ?? ""
        )
        .replace(
          "@organiserAddress@",
          formValue?.Invoicebyid?.organiserAddress
            ?? ""
        )
        .replace(
          "@traderLegalBusinessName@",
          formValue?.Invoicebyid?.traderLegalBusinessName
            ?? ""
        )
        .replace(
          "@invoiceDate@",
          formValue?.Invoicebyid?.invoiceDate
            ? formatDateENGB(formValue?.Invoicebyid?.invoiceDate)
            : ""
        )
        .replace(
          "@traderAddress@",
          formValue?.Invoicebyid?.traderAddress
            ?? ""
        )

        //Table

        .replace(
          "@litterBond@",
          formValue?.Invoicebyid?.litterBond
            ? "£" + formatAmount(formValue?.Invoicebyid?.litterBond)
            : ""
        )
        .replace(
          "@tax@",
          formValue?.Invoicebyid?.vat
            ? "£" + formatAmount(formValue?.Invoicebyid?.vat)
            : ""
        )
        .replace(
          "@subTotal@",
          formValue?.Invoicebyid?.totalAmount
            ? "£" +
                formatAmount(
                  formValue?.Invoicebyid?.totalAmount -
                    (formValue?.Invoicebyid?.vat
                      ? formValue?.Invoicebyid?.vat
                      : 0) -
                    (formValue?.Invoicebyid?.litterBond
                      ? formValue?.Invoicebyid?.litterBond
                      : 0)
                )
            : ""
        )
        .replace(
          "@balancedue@",
          "£" +
            formatAmount(
              formValue?.Invoicebyid?.totalAmount
                ? formValue?.Invoicebyid?.totalAmount
                : 0
            )
        )

        // Table
        .replace(
          " @table@",
          (formValue.Invoicebyid?.objInvoiceDetailListViewModel ?? [])
            .map(
              (msd) =>
                `<tr>
                      <td>${msd?.qty ??  "-"}</td>
                      <td>${msd?.item ??  "-"}</td>
                      <td>${msd?.description ?? "-"}</td>
                       <td>N/A</td>
                      <td>${msd?.taxable === true ? "Yes" : "No"}</td>
                      <td>${
                        msd?.unitPrice ? "£" + formatAmount(msd?.unitPrice) : "-"
                      }</td>
                      <td>${
                        msd?.unitPrice && msd?.qty
                          ? "£" + formatAmount(msd?.unitPrice * msd?.qty)
                          : "-"
                      }</td>
                </tr> `
            )
            .join("")
        );

      const opt = {
        margin: [20, 20, 20, 20],
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        filename: `Retail_Trade_Stand_Invoice.pdf`,
        image: { type: "jpeg", quality: 0.2 },
        html2canvas: {
          dpi: 150,
          scale: 2,
          letterRendering: true,
          useCORS: true,
          // scrollY: 2,
        },
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "portrait",
          putTotalPages: true,
          before: ".nextpage1",
          compress: true,
        },
      };

      return new Promise((resolve, reject) => {
        html2pdf()
          .set(opt)
          .from(html)
          .toPdf()
          .output("blob") // Generate the PDF as a Blob
          .then((pdfBlob) => {
            const file = new File([pdfBlob], "Retail_Trade_Stand_Invoice.pdf", {
              type: "application/pdf",
            });
            resolve(file); // Return the PDF as a File object
          })
          .catch((error) => {
            handleConsoleError(error);
            reject(error);
          });
      });
    } catch (error) {
      handleConsoleError(error);
      throw error;
    }
  };

  //****   Invoice Admin Data  *****
  const InvoiceAdminData = async (eventApplicationId) => {
    try {
      let invoiceAdmin = {};
      const resInvoiceByid = await InvoiceService.getInvoiceMainData(
        eventApplicationId,
        "R",
        true
      );
      if (resInvoiceByid?.isSuccess) {
        invoiceAdmin = resInvoiceByid?.data;
      }

      setFormValues((prev) => ({
        ...prev,
        invoiceAdmin: invoiceAdmin, // updated value
      }));
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  //******  Invoice Admin PDF CODE *****************
  const InvoiceAdminPdf = async (formValue) => {
    try {
      let html = globalConstant.InvoiceAdminHTML;

      const adminInvoice =
        formValue.invoiceAdmin?.objInvoiceDetailListViewModel ?? [];

      const adminItemList =
        adminInvoice.filter(
          (x) =>
            x.item.toLowerCase().includes("application") ||
            x.item.toLowerCase().includes("buyer")
        ) ?? [];

      // formValue.invoiceAdmin.totalAmount = adminItemList.reduce(
      //   ((acc, x) => acc + x.unitPrice * x.qty, 0)
      // );
      // formValue.invoiceAdmin.totalAmount = adminItemList.reduce(
      //   (acc, item) => acc + item.unitPrice * item.qty,
      //   0
      // );

      html = html
        .toString()
        .replace(
          "@vatNumber@",
          formValue?.invoiceAdmin?.vatNo ?? ""
        )
        .replace(
          "@businessLogoUrl@",
          formValue?.invoiceAdmin?.businessLogo || ""
        )
        .replace(
          "@businessRegistrationNumber@",
          formValue?.invoiceAdmin?.vatNo ??  ""
        )
        .replace(
          "@vat@",
          formValue?.invoiceAdmin?.vat ??  ""
        )
        .replace(
          "@invoiceNo@",
          formValue?.invoiceAdmin?.invoiceNo
            ??  ""
        )
        .replace(
          "@address@",
          formValue?.invoiceAdmin?.city ??  ""
        )
        .replace(
          "@invoiceAddress@",
          formValue?.invoiceAdmin?.invoiceAddress
            ??  ""
        )
        .replace(
          "@businessLogoUrl@",
          formValue?.invoiceAdmin?.businessLogoUrl
            ??  ""
        )
        .replace(
          "@eventName@",
          formValue?.invoiceAdmin?.eventName
            ??  ""
        )
        .replace(
          "@organiserLegalBusinessName@",
          formValue?.invoiceAdmin?.organiserLegalBusinessName
            ?? ""
        )
        .replace(
          "@organiserLegalBusinessName@/g",
          formValue?.invoiceAdmin?.organiserLegalBusinessName
            ?? ""
        )
        .replace(
          "@organiserAddress@",
          formValue?.invoiceAdmin?.organiserAddress
            ?? ""
        )
        .replace(
          "@traderLegalBusinessName@",
          formValue?.invoiceAdmin?.traderLegalBusinessName
            ?? ""
        )
        .replace(
          "@invoiceDate@",
          formValue?.invoiceAdmin?.invoiceDate
            ? formatDateENGB(formValue?.invoiceAdmin?.invoiceDate)
            : ""
        )
        .replace(
          "@traderAddress@",
          formValue?.invoiceAdmin?.traderAddress
            ?? ""
        )

        //Table

        .replace(
          "@litterBond@",
          formValue?.invoiceAdmin?.litterBond
            ? "£" + formatAmount(formValue?.invoiceAdmin?.litterBond)
            : ""
        )
        .replace(
          "@tax@",
          formValue?.invoiceAdmin?.vat
            ? "£" + formatAmount(formValue?.invoiceAdmin?.vat)
            : ""
        )
        .replace(
          "@subTotal@",
          formValue?.invoiceAdmin?.totalAmount
            ? "£" +
                formatAmount(
                  formValue?.invoiceAdmin?.totalAmount -
                    (formValue?.invoiceAdmin?.vat
                      ? formValue?.invoiceAdmin?.vat
                      : 0) -
                    (formValue?.invoiceAdmin?.litterBond
                      ? formValue?.invoiceAdmin?.litterBond
                      : 0)
                )
            : ""
        )
        .replace(
          "@balancedue@",
          "£" +
            formatAmount(
              formValue?.invoiceAdmin?.totalAmount
                ? formValue?.invoiceAdmin?.totalAmount
                : 0
            )
        )

        // Table
        .replace(
          " @table@",
          adminItemList
            .map(
              (msd) =>
                `<tr>
                      <td>${msd?.qty ??"-"}</td>
                      <td>${msd?.item ?? "-"}</td>
                      <td>${msd?.description ??  "-"}</td>
                       <td>N/A</td>
                      <td>${msd?.taxable === true ? "Yes" : "No"}</td>
                      <td>${
                        msd?.unitPrice ? "£" + formatAmount(msd?.unitPrice) : "-"
                      }</td>
                      <td>${
                        msd?.unitPrice && msd?.qty
                          ? "£" + formatAmount(msd?.unitPrice * msd?.qty)
                          : "-"
                      }</td>
                </tr> `
            )
            .join("")
        );

      const opt = {
        margin: [20, 20, 20, 20],
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        filename: `Retail_Trade_Stand_Admin_Invoice.pdf`,
        image: { type: "jpeg", quality: 0.2 },
        html2canvas: {
          dpi: 150,
          scale: 2,
          letterRendering: true,
          useCORS: true,
          // scrollY: 2,
        },
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "portrait",
          putTotalPages: true,
          before: ".nextpage1",
          compress: true,
        },
      };

      return new Promise((resolve, reject) => {
        html2pdf()
          .set(opt)
          .from(html)
          .toPdf()
          .output("blob") // Generate the PDF as a Blob
          .then((pdfBlob) => {
            const file = new File(
              [pdfBlob],
              "Retail_Trade_Stand_Admin_Invoice.pdf",
              {
                type: "application/pdf",
              }
            );
            resolve(file); // Return the PDF as a File object
          })
          .catch((error) => {
            handleConsoleError(error);
            reject(error);
          });
      });
    } catch (error) {
      handleConsoleError(error);
      throw error;
    }
  };

  //************ Send Final Mail ***********************************************************
  const sendingMail = async (formValue) => {
    props.application.setLoading(true);
    try {
      //Invoice
      const invoice = await InvoicePdf(formValue);
      const requestData = {
        EventApplicationId: appId,
        ApplicationFor: "R",
        DocumentType: 0,
        DocumentFile: invoice,
      };
      const response = await DocumentService.EventApplicationAddDocument(
        requestData
      );
      if (response?.isSuccess) {
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }

      //Retails PDF
      const requestcatersData = {
        EventApplicationId: appId,
        ApplicationFor: "R",
        DocumentType: 2,
        DocumentFile: null,
      };
      const responsecaters = await DocumentService.EventApplicationAddDocument(
        requestcatersData
      );
      if (responsecaters?.isSuccess) {
        toast.success(responsecaters?.message);
      } else {
        toast.error(responsecaters?.message);
      }

      //HandBooks
      if ((booking.contractId = "ff33a351-5b7c-437b-8eb4-6190379ec1be")) {
        const handbookPDF = await handbookspdf(booking, formValue);
        const requestData = {
          EventApplicationId: appId,
          ApplicationFor: "R",
          DocumentType: 1,
          DocumentFile: handbookPDF,
        };
        const response = await DocumentService.EventApplicationAddDocument(
          requestData
        );
        if (response?.isSuccess) {
          toast.success(response?.message);
        } else {
          toast.error(response?.message);
        }
      }

      //Terms And Conditon
      if ((booking.contractId = "fb548739-decc-4d14-8219-2c66cb9f1897")) {
        const termsandconditionspdf = await TermsAndConditionspdf(
          booking,
          formValue
        );
        const requestData = {
          EventApplicationId: appId,
          ApplicationFor: "R",
          DocumentType: 3,
          DocumentFile: termsandconditionspdf,
        };

        const response = await DocumentService.EventApplicationAddDocument(
          requestData
        );
        if (response?.isSuccess) {
          toast.success(response?.message);
        } else {
          toast.error(response?.message);
        }
      }

      //InvoiceAdmin
      const invoiceAdmin = await InvoiceAdminPdf(formValue);
      const requestAdminData = {
        EventApplicationId: appId,
        ApplicationFor: "R",
        DocumentType: 4,
        DocumentFile: invoiceAdmin,
      };
      const responseAdmin = await DocumentService.EventApplicationAddDocument(
        requestAdminData
      );
      if (responseAdmin?.isSuccess) {
        toast.success(response?.message);
      } else {
        toast.error(responseAdmin?.message);
      }

      await FinalEmail();
      navigate(
        routes.SUBMISSION_RETAILER.replace(":eventId", appData?.eventId)
      );
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  // ********** Final Email Api
  const FinalEmail = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const response = await DocumentTypeService.getEventApplicationDocumentByAppId(
          appId,
          "R"
        );
        if (response?.isSuccess) {
          toast.success(response?.message);
        } else {
          toast.error(response?.message);
        }

        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  //*******************************************************************************************************/

  const showPaymentStatus = () => {
    if (paymentStatus === PaymentStatus.Paid) {
      return "Paid";
    }
    if (paymentStatus === PaymentStatus.PartiallyPaid) {
      return "Partially Paid";
    }
    return "Unpaid";
  };
  const showApplicationStatus = () => {
    if (appData?.status === ApplicationStatus.Approved) {
      return "Approved";
    }

    if (appData?.status === ApplicationStatus.Awaiting) {
      return "Awaiting";
    }
    if (appData?.status === ApplicationStatus.Rejected) {
      return "Rejected";
    }
    if (appData?.status === ApplicationStatus.Withdraw) {
      return "Withdraw";
    }
    if (appData?.status === ApplicationStatus.InComplete) {
      return "InComplete";
    }
    if (appData?.status === ApplicationStatus.Completed) {
      return "Completed";
    }
    return "Awaiting";
  };
  // ***********Contact New Code *******************************************************

  return (
    <React.Fragment>
      <div className="container mt-3">
        <React.Fragment>
          {" "}
          <div
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
            className="row"
          >
            <h3
              style={{
                color: "#ffffff",
              }}
              className="col-6"
            >
              Details
            </h3>

            <span className="col-3 text-end">
              Appliction Status :: {showApplicationStatus()}
            </span>
            <span className="col-3 text-end">
              Payment Status :: {showPaymentStatus()}
              {IsBankPayment && (
                <button
                  type="button"
                  style={{ padding: "5px 20px" }}
                  className="me-1 mb-1 me-sm-3"
                  onClick={() => handleBankPaymentOpenModal()}
                >
                  Paid in full
                </button>
              )}
            </span>
          </div>
          <section className="edit-form-table">
            <div className="">
              <div className="table-responsive">
                <Table striped bordered hover>
                  <tbody>
                    <tr>
                      <td>Company Name</td>
                      <td style={isApproved ? {} : getObscuredText()}>
                        {getObscuredTextLabel(businessData?.businessName)}
                      </td>
                    </tr>
                    <tr>
                      <td>Contact Name</td>
                      <td style={isApproved ? {} : getObscuredText()}>
                        {getObscuredTextLabel(businessData?.contactlegalname)}
                      </td>
                    </tr>
                    <tr>
                      <td>Address</td>
                      <td>
                        {businessData?.address ? businessData?.address : ""}
                        {businessData?.city ? `, ${businessData?.city}` : ""}
                        {businessData?.zipCode
                          ? `, ${businessData?.zipCode}`
                          : ""}
                        {businessData?.stateName
                          ? `, ${businessData?.stateName}`
                          : ""}
                        {businessData?.countryName
                          ? `, ${businessData?.countryName}`
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>Email Address</td>
                      <td style={isApproved ? {} : getObscuredText()}>
                        {getObscuredTextLabel(businessData?.email)}
                      </td>
                    </tr>
                    <tr>
                      <td>Phone/Mobile Number</td>
                      <td style={isApproved ? {} : getObscuredText()}>
                        {getObscuredTextLabel(businessData?.phone)}
                      </td>
                    </tr>
                    <tr>
                      <td>On Site Contact </td>
                      <td style={isApproved ? {} : getObscuredText()}>
                        {getObscuredTextLabel(appData?.onSiteContact)}
                      </td>
                    </tr>
                    <tr>
                      <td>On Site Tel</td>
                      <td style={isApproved ? {} : getObscuredText()}>
                        {getObscuredTextLabel(appData?.onSiteTel)}
                      </td>
                    </tr>
                    <tr>
                      <td>Business Registration Number</td>
                      <td style={isApproved ? {} : getObscuredText()}>
                        {getObscuredTextLabel(
                          businessData?.businessRegistrationNumber
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Selected Unit</td>
                      <td>{appData?.traderPitchName} </td>
                    </tr>
                    <tr>
                      <td>Initial Payment</td>
                      <td>
                        {appData?.initialPaymentPer}
                        {"%"}
                      </td>
                    </tr>
                    {appData?.initialPaymentPer < 100 && (
                      <React.Fragment>
                        <tr>
                          <td style={{ color: "red" }}>
                            <strong>Second Stage Payment Deadline</strong>
                          </td>
                          <td style={{ color: "red" }}>
                            <strong>
                              {formatDateENGB(appData?.payOutDate)}
                            </strong>{" "}
                          </td>
                        </tr>

                        {/* <tr>
                          <td style={{ color: "red" }}>Second Stage Due Payment</td>
                          <td style={{ color: "red" }}>
                            <strong>
                              {remainingAmount > 0
                                ? "£" + formatAmount(remainingAmount)
                                : ""}{" "}
                            </strong>
                          </td>
                        </tr> */}
                      </React.Fragment>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
        </React.Fragment>
        <hr />
        <React.Fragment>
          {" "}
          <div className="sub-form-item">
            <span>Describes Stand :</span> {appData?.describesyourstand}
          </div>
          <div className="sub-form-item">
            <span>Item Sold :</span> {appData?.itemstobesold}
          </div>
          <h3
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
            className="mt-3"
          >
            Pitch Details
          </h3>
          <section className="edit-form-table">
            <div className="">
              <div className="table-responsive">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "left",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "center",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Quantity
                      </th>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "center",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Price (£)
                      </th>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "center",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Pitch Number
                      </th>
                      {loginUser?.role === UserRoleType.EO && (
                        <th
                          style={{
                            fontSize: "13px",
                            lineHeight: "16px",
                            textAlign: "center",
                            padding: "5px !important",
                            verticalAlign: "middle",
                            background: "#d1d1d1 !important",
                          }}
                        >
                          Action
                        </th>
                      )}
                      {/* <th>Describes Stand </th>
                    <th>Item Sold</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {pitchData && pitchData.length > 0 ? (
                      <React.Fragment>
                        {pitchData.map((item, idx) => {
                          return (
                            <tr key={idx}>
                              {/* <td>{item.location}</td> */}
                              <td style={{ textAlign: "left" }}>
                                {item?.pitchName}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item?.pitchQty}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                £{formatAmount(item?.pitchPrice)}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item?.allocatedPitchNo || ""}
                              </td>
                              {loginUser?.role === UserRoleType.EO && (
                                <td style={{ textAlign: "center" }}>
                                  <a
                                    href="#!"
                                    onClick={() =>
                                      handleOpenModal(
                                        item?.id,
                                        item?.allocatedPitchNo
                                      )
                                    }
                                    style={{ fontSize: "18px" }}
                                  >
                                    <i className="fa fa-plus"></i>{" "}
                                    {/* Plus icon */}
                                  </a>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    ) : (
                      <tr>
                        <td colSpan="10 mt-2">No results found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
        </React.Fragment>

        <React.Fragment>
          <h3
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
            className=""
          >
            Furniture
          </h3>
          <section className="edit-form-table">
            <div className="">
              <div className="table-responsive">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "left",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "center",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Quantity
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Trestle Table{" "}
                        {appData?.trestletablePrice > 0 &&
                          "(£" + formatAmount(appData?.trestletablePrice) + ")"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {appData?.trestletable === true ? 1 : 0}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Banner rail for tents
                        {appData?.bannerrailfortentsPrice > 0 &&
                          "(£" +
                            formatAmount(appData?.bannerrailfortentsPrice) +
                            ")"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {appData?.bannerrailfortents === true ? 1 : 0}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Additional ground passes
                        {appData?.additionalpassesPrice > 0 &&
                          "(£" +
                            formatAmount(appData?.additionalpassesPrice) +
                            ")"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {appData?.additionalpasses > 0
                          ? appData?.additionalpasses
                          : "0"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
        </React.Fragment>
        <hr />

        <React.Fragment>
          <h3
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
            className=""
          >
            Electrical Connection
          </h3>
          <section className="edit-form-table">
            <div className="">
              <div className="table-responsive">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "left",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "center",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Quantity
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        13 amp twin-sockets
                        {appData?.twinsockets13ampPrice > 0 &&
                          "(£" +
                            parseFloat(appData?.twinsockets13ampPrice).toFixed(
                              2
                            ) +
                            ")"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {appData?.twinsockets13amp === true ? 1 : 0}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        16 amp{" "}
                        {appData?.amp16Price > 0 &&
                          "(£" + formatAmount(appData?.amp16Price) + ")"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {appData?.amp16 === true ? 1 : 0}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        32 amp
                        {appData?.amp32Price > 0 &&
                          "(£" + formatAmount(appData?.amp32Price) + ")"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {appData?.amp32 === true ? 1 : 0}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
          <h3
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
            className=""
          >
            Documents
          </h3>
          <section className="edit-form-table">
            <div className="">
              <div className="table-responsive">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "left",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "left",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Expiry Date
                      </th>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "left",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentList && documentList.length > 0 ? (
                      <React.Fragment>
                        {documentList.map((item, idx) => {
                          return (
                            <tr key={idx}>
                              <td>{item?.documentTypeName} </td>
                              <td>{formatDateENGB(item?.expiryDate)} </td>

                              <td>
                                {isApproved && item?.isFile && (
                                  <a
                                    href={item?.docPathUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <i className="fa fa-eye"></i>
                                  </a>
                                )}
                                {!item?.isFile && item?.docPathUrl}
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    ) : (
                      <tr style={{ textAlign: "center" }}>
                        <td colSpan="10 mt-2">No document found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
        </React.Fragment>
        <hr />
        <React.Fragment>
          <h3
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
          >
            Payment Details
          </h3>
          <section className="edit-form-table">
            <div className="">
              <div className="table-responsive">
                {/* BACS		◻ */}
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "left",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Item
                      </th>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "center",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Amount(£)
                      </th>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "center",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Vat(£)
                      </th>
                      <th
                        style={{
                          fontSize: "13px",
                          lineHeight: "16px",
                          textAlign: "center",
                          padding: "5px !important",
                          verticalAlign: "middle",
                          background: "#d1d1d1 !important",
                        }}
                      >
                        Total(£)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <React.Fragment>
                      {litterData?.map((item, idx) => {
                        return (
                          <tr key={idx}>
                            <td>{item?.name}</td>
                            <td style={{ textAlign: "center" }}>
                              £{formatAmount(item?.amount)}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              £{formatAmount(item?.vat)}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              £{formatAmount(item?.total)}
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
        </React.Fragment>
        {location.pathname.startsWith("/events") && (
          <div>
            {appData?.status !== ApplicationStatus.Approved &&
              appData?.isSigned &&
              appData?.status !== ApplicationStatus.Completed &&
              appData?.status !== ApplicationStatus.Rejected && (
                <button
                  type="button"
                  className="me-1 me-sm-3"
                  onClick={() => handleApprove()}
                >
                  Approve
                </button>
              )}
            {appData?.status !== ApplicationStatus.Rejected &&
              appData?.status !== ApplicationStatus.Completed && (
                <button
                  type="button"
                  className="me-1 me-sm-3"
                  onClick={() => handleAccept(ApplicationStatus.Rejected)}
                >
                  Reject
                </button>
              )}
            {appData?.finalizeStatus &&
              appData?.status !== ApplicationStatus.Rejected && (
                <button
                  type="button"
                  className="me-1 mb-1 me-sm-3"
                  onClick={async () => await sendingMail(formValue)}
                >
                  Resend Documentation Email
                </button>
              )}

            {appData?.finalizeStatus &&
              appData?.status !== ApplicationStatus.Rejected && (
                <button
                  type="button"
                  className="me-1 mb-1 me-sm-3"
                  onClick={() => window.open(showurl, "_blank")}
                >
                  View Contract
                </button>
              )}
            {appData?.traderInvoiceURL && (
              <button
                type="button"
                className="me-1 mb-1 me-sm-3"
                onClick={() => window.open(appData?.traderInvoiceURL, "_blank")}
              >
                View Trader Invoice
              </button>
            )}
            {appData?.platformInvoiceURL && (
              <button
                type="button"
                className="me-1 mb-1 me-sm-3"
                onClick={() =>
                  window.open(appData?.platformInvoiceURL, "_blank")
                }
              >
                View Platfrom Invoice
              </button>
            )}
          </div>
        )}
        {location.pathname.startsWith("/traders") && (
          <div>
            <button
              type="button"
              className="me-1 mb-1 ms-3"
              onClick={handleBack}
            >
              Back
            </button>
            {appData?.traderInvoiceURL && (
              <button
                type="button"
                className="me-1 mb-1 me-sm-3"
                onClick={() => window.open(appData?.traderInvoiceURL, "_blank")}
              >
                View Invoice
              </button>
            )}
          </div>
        )}
        {/* Modal for adding/editing Allocation */}
        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Allocation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Pitch Number</Form.Label>
                <Form.Control
                  type="text"
                  value={newAllocatedPitchNo}
                  onChange={handleInputChange}
                  placeholder="Enter pitch number"
                />
                {error && (
                  <Form.Text className="text-danger">{error}</Form.Text>
                )}
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        
                {/* Modal for bank manual payment */}
                <Modal show={showBankPaymentModal} onHide={handleCloseBankPaymentModal} centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Update Bank Payment Status</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Form.Group>
                        <Form.Label>Comment</Form.Label>
                        <Form.Control
                          type="text" 
                          maxLength={200}
                          value={bankPaymentComment}                
                          onChange={handleCommentInputChange}
                          placeholder="Enter commnet"
                        />
                        {error && (
                          <Form.Text className="text-danger">{error}</Form.Text>
                        )}
                      </Form.Group>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseBankPaymentModal}>
                      Close
                    </Button>
                    <Button variant="primary" onClick={handleBankPayment}>
                      Save
                    </Button>
                  </Modal.Footer>
                </Modal>
      </div>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EventRetailerSubmissionDetails);
